module.exports = __webpack_public_path__ + "img/kiss_mark.68d09552.gif";